import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import DB_Sale from "../../../database/document/sale";
import ModalWindow from "../../modal";
import {Outlet, useLocation} from "react-router-dom";
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Divider,
    Form,
    Popconfirm,
    Row,
    Select,
    Skeleton,
    Space,
    Spin,
    Table,
    Typography
} from "antd";

import moment from "moment/moment";
import DB_Warehouse from "../../../database/dictionary/warehouse";
import {DebounceSelect} from "../../tech/search_input";
import DB_OrgStructure from "../../../database/dictionary/org_structures";
import DB_TradePoint from "../../../database/dictionary/trade-point";
import EditableCell from "../../tech/editable_cell";
import BackButton from "../../tech/back_button";

const EditSale = () => {
    const {token, setToken, user} = useContext(Context);
    const {t} = useTranslation();
    const {getSale, updateInvoice, updateInvoiceDetails} = DB_Sale(token)
    const {getActiveWarehouses} = DB_Warehouse(token)
    const {getOrgStructureFilter} = DB_OrgStructure(token)
    const {getTradePointFilter} = DB_TradePoint(token)
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const [wait, setWait] = useState(true);
    const [waitSpin, setWaitSpin] = useState(false);
    const [data, setData] = useState({});
    const [detailsData, setDetailsData] = useState([])
    const [warehouses, setWarehouses] = useState([])
    const [update, setUpdate] = useState(true)
    const [form] = Form.useForm()
    const [formTable] = Form.useForm()
    const [addPositions, setAddPositions] = useState(false)
    const [updateDetails, setUpdateDetails] = useState(false)

    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.id === editingKey;
    const edit = (record) => {
        if (record == null) { return }
        formTable.setFieldsValue({
            vendor_code_id: '',
            count: '',
            price: '',
            sum_without_tax: '',
            tax: '',
            sum_with_tax: '',
            ...record,
        });
        setEditingKey(record.id);
    };
    const cancel = () => {
        setEditingKey('');
        if (addPositions) {
            setDetailsData(detailsData.slice(0, detailsData.length - 1))
            setAddPositions(false)
        }
    }

    const save = async (key) => {
        try {
            const row = await formTable.validateFields();
            const newData = [...detailsData];
            const index = newData.findIndex((item) => key === item.id);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
            } else {
                newData.push(row);
                // setDetailsData(newData);
                // setEditingKey('');
            }

            setUpdateDetails(true)
            setDetailsData(newData)


        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const del = (id) => {
        setUpdateDetails(true)
        setDetailsData(detailsData.filter(i => i.id !== id))
    }

    useEffect(() => {
        if (updateDetails) {
            const data = {
                sale_id: params.id,
                details: detailsData
            }
            setWaitSpin(true)
            updateInvoiceDetails(data)
                .then(res => {
                    if (res.request.status === 200) {
                        setUpdate(!update)
                    }
                })
                .catch(e => {

                })
                .finally(() => {
                        setWaitSpin(false)
                        setUpdateDetails(false)
                        setEditingKey('');
                    }
                )
        }
    }, [updateDetails])


    const columns = [

        {
            title: "#",
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: t('code'),
            dataIndex: 'vendor_code_id',
            editable: true,
        },
        {
            title: t('sku'),
            dataIndex: 'vendor_code',
        },
        {
            title: t('quantity'),
            dataIndex: 'count',
            editable: true,
        },
        {
            title: t('price'),
            dataIndex: 'price',
            editable: true,
        },
        {
            title: t('sum_without_tax'),
            dataIndex: 'sum_without_tax',
            editable: true,
        },
        {
            title: t('tax'),
            dataIndex: 'tax',
            editable: true,
        },
        {
            title: t('sum_with_tax'),
            dataIndex: 'sum_with_tax',
            editable: true,
        },
        {
            title: '',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
            <Typography.Link
                onClick={() => save(record.id)}
                style={{
                    marginRight: 8,
                }}
            >
              {t('save')}
            </Typography.Link>
                        <Typography.Link
                            onClick={() => del(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
              {t('delete')}
            </Typography.Link>
            <Popconfirm title={t('q_sure_cancel')} onConfirm={cancel}>
              <a>{t('cancel')}</a>
            </Popconfirm>
          </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        {t('edit')}
                    </Typography.Link>
                );
            },
        },
    ]


    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'vendor_code_id'
                || col.dataIndex === 'count'
                || col.dataIndex === 'price'
                || col.dataIndex === 'sum_without_tax'
                || col.dataIndex === 'tax'
                || col.dataIndex === 'sum_with_tax'
                    ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });


    useEffect(() => {
        if (params.id != null) {
            getSale(params.id)
                .then(res => {
                    setData(res.data)
                    setDetailsData(res.data['details'])
                    form.setFieldsValue({
                            org_structure: {
                                key: res.data.org_structure_id,
                                label: res.data.org_structure,
                                value: res.data.org_structure_id
                            },
                            trade_point: {
                                key: res.data.trade_point.id,
                                label: res.data.trade_point.name,
                                value: res.data.trade_point.id
                            },
                            warehouse: res.data.warehouse_id,
                        }
                    )
                })
                .catch(e => {
                    if (e.response.status === 403) {
                        setToken(null)
                    }
                    errorConnect()
                })
                .finally(() => {
                    setWait(false)
                    setEditingKey('')
                    setAddPositions(false)
                })
        }

    }, [update])

    useEffect(() => {
        getActiveWarehouses(data.branch_id)
            .then(res => {
                setWarehouses(res.data)
            })
            .catch(e => {
                if (e.response.status === 403) {
                    setToken(null)
                }
                errorConnect()
            })
    }, [data])


    const clickSaveSale = () => {

        setWaitSpin(true)

        const data = {
            sale_id: params.id,
            warehouse_id: form.getFieldValue('warehouse'),
            org_structure_id: form.getFieldValue('org_structure').value,
            trade_point_id: form.getFieldValue('trade_point').value
        }

        updateInvoice(data)
            .then(res => {
                if (res.request.status === 200) {
                    window.history.back()
                }
            })
            .catch(e => {
                if (e.response.status === 403) {
                    setToken(null)
                }
                errorConnect()
            })
            .finally(() => {
                setWaitSpin(false)
                setAddPositions(false)
            })
    }

    const SaveButton = () => {
        return (
            <Button type={'primary'} onClick={clickSaveSale}>
                {t('save')}
            </Button>
        )
    }

    const handleAdd = () => {
        const newData = {
            id: detailsData.length + 1,
            vendor_code_id: '',
            count: '',
            price: '',
            sum_without_tax: '',
            tax: '',
            sum_with_tax: '',
        };
        setAddPositions(true)
        setDetailsData([...detailsData, newData]);
    };

    useEffect(() => {
        if (addPositions) {
            edit(detailsData[detailsData.length - 1])
        }
    }, [detailsData])


    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('invoice') + data.invoice_number}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton />
                        <Button type={'primary'} shape={'round'} onClick={clickSaveSale}>
                            {t('save')}
                        </Button>
                    </Space>
                </Space>

                <Skeleton loading={wait} active>
                    <Card
                        // title={t('invoice') + data.invoice_number}
                        // extra={[
                        //     <SaveButton key={2}/>,
                        //     <BlockButton key={1}/>,
                        // ]
                        // }
                    >
                        <Form
                            form={form}
                            name="advanced_search"
                            className="ant-advanced-search-form"
                            layout={"horizontal"}
                        >

                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item
                                        name='date'
                                        label={t('date')}
                                    >
                                    <span
                                        style={{fontFamily: 'Montserrat-Medium'}}>{moment(data.date).format("DD.MM.YYYY")}</span>
                                    </Form.Item>
                                </Col>

                                <Col span={16}>
                                    <Form.Item
                                        name='branch'
                                        label={t('branch')}
                                    >
                                    <span
                                        style={{fontFamily: 'Montserrat-Medium'}}>{data.branch}</span>
                                    </Form.Item>
                                </Col>


                            </Row>

                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item
                                        name='warehouse'
                                        label={t('warehouse')}

                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="name"
                                            optionLabelProp="name">
                                            {
                                                warehouses.map(w =>
                                                    <Select.Option key={w.id} value={w.id}
                                                                   name={w.name}>{w.name}</Select.Option>
                                                )
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={16}>
                                    <Form.Item
                                        name='org_structure'
                                        label={t('org_structure_s')}
                                    >
                                        <DebounceSelect
                                            // mode="multiple"
                                            showSearch
                                            fetchOptions={getOrgStructureFilter}

                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item
                                        name='doc_type'
                                        label={t('doc_type')}
                                    >
                                        <span style={{fontFamily: 'Montserrat-Medium'}}>{data.doc_type}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={16}>
                                    <Form.Item
                                        name='trade_point'
                                        label={t('trade_point')}
                                    >
                                        <DebounceSelect
                                            // mode="multiple"
                                            showSearch
                                            fetchOptions={getTradePointFilter}
                                            branch={data.branch_id}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>

                        <Divider/>

                        <div style={{marginBottom: '10pt', display: 'flex', justifyContent: 'end'}}>
                            <Button onClick={handleAdd}>{t('add')}</Button>
                        </div>

                        <Spin delay={300} spinning={waitSpin}>
                            <Form form={formTable} component={false}>
                                <Table
                                    // columns={columns}
                                    columns={mergedColumns}
                                    dataSource={detailsData}
                                    rowKey="id"
                                    loading={wait}
                                    pagination={false}
                                    // pagination={{
                                    //     position: ['none', 'none'],
                                    // }}
                                    size={"small"}
                                    components={{
                                        body: {
                                            cell: EditableCell,
                                        },
                                    }}
                                />
                            </Form>
                        </Spin>

                    </Card>
                </Skeleton>

            </div>
            <Outlet/>
        </>
    )
}

export default EditSale